/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(['underscore'], (_) => {
	const TEXT_WIDGET_TYPE = 'text';
	const THEME_DEFAULT = 'defaultTheme';
	const TEXT_CLASS_MAPS = {};
	TEXT_CLASS_MAPS[THEME_DEFAULT] = {
		'subtitleFontFamily': 'rt_fontFamilyHelvNeueforIBM-Light',
		'titleFontFamily': 'rt_fontFamilyHelvNeueforIBM-Bold',
		'titleSmallFontFamily': 'rt_fontFamilyHelvNeueforIBM-Regular',
		'bodyFontFamily': 'rt_fontFamilyHelvNeueforIBM-Regular',
		'bodySmallFontFamily': 'rt_fontFamilyHelvNeueforIBM-Regular',
		'captionFontFamily': 'rt_fontFamilyHelvNeueforIBM-Regular',
		'quoteFontFamily': 'rt_fontFamilyHelvNeueforIBM-Light',
		'quoteSmallFontFamily': 'rt_fontFamilyHelvNeueforIBM-Light',
		'subtitleFontSize': 'rt_fontSize18',
		'titleFontSize': 'rt_fontSize16',
		'titleSmallFontSize': 'rt_fontSize20',
		'bodyFontSize': 'rt_fontSize16',
		'bodySmallFontSize': 'rt_fontSize14',
		'captionFontSize': 'rt_fontSize14',
		'quoteFontSize': 'rt_fontSize18',
		'quoteSmallFontSize': 'rt_fontSize16',
		'subtitleText': 'subtitleColor rt_fontFamilyHelvNeueforIBM-Light rt_fontSize18',
		'titleText': 'titleColor rt_fontFamilyHelvNeueforIBM-Bold rt_fontSize20',
		'titleSmallText': 'titleSmallColor rt_fontFamilyHelvNeueforIBM-Regular rt_fontSize20',
		'bodyText': 'bodyColor rt_fontFamilyHelvNeueforIBM-Regular rt_fontSize16',
		'bodySmallText': 'bodySmallColor rt_fontFamilyHelvNeueforIBM-Regular rt_fontSize14',
		'captionText': 'captionColor rt_fontFamilyHelvNeueforIBM-Regular rt_fontSize14',
		'quoteText': 'quoteColor rt_fontFamilyHelvNeueforIBM-Light rt_fontSize18',
		'quoteSmallText': 'quoteSmallColor rt_fontFamilyHelvNeueforIBM-Light rt_fontSize16',
		'responsiveText': 'responsiveColor responsiveFontSize responsiveFontFamily',
		'responsiveFontFamily': 'responsiveFontFamilyHelvetica' // used for Endor R7 upgrade: keep the old default font family
	};
	TEXT_CLASS_MAPS['lightTheme'] = {
		'subtitleFontFamily': 'rt_fontFamilyMerriweather-Light',
		'titleFontFamily': 'rt_fontFamilyMerriweather-Bold',
		'titleSmallFontFamily': 'rt_fontFamilyMerriweather-Regular',
		'bodyFontFamily': 'rt_fontFamilyMerriweather-Light',
		'bodySmallFontFamily': 'rt_fontFamilyMerriweather-Light',
		'captionFontFamily': 'rt_fontFamilyMerriweather-Regular',
		'quoteFontFamily': 'rt_fontFamilyMerriweather-Light',
		'quoteSmallFontFamily': 'rt_fontFamilyMerriweather-Light',
		'subtitleFontSize': 'rt_fontSize18',
		'titleFontSize': 'rt_fontSize16',
		'titleSmallFontSize': 'rt_fontSize20',
		'bodyFontSize': 'rt_fontSize16',
		'bodySmallFontSize': 'rt_fontSize14',
		'captionFontSize': 'rt_fontSize14',
		'quoteFontSize': 'rt_fontSize18',
		'quoteSmallFontSize': 'rt_fontSize16',
		'subtitleText': 'subtitleColor rt_fontFamilyMerriweather-Light rt_fontSize18',
		'titleText': 'titleColor rt_fontFamilyMerriweather-Bold rt_fontSize20',
		'titleSmallText': 'titleSmallColor rt_fontFamilyMerriweather-Regular rt_fontSize20',
		'bodyText': 'bodyColor rt_fontFamilyMerriweather-Light rt_fontSize16',
		'bodySmallText': 'bodySmallColor rt_fontFamilyMerriweather-Light rt_fontSize14',
		'captionText': 'captionColor rt_fontFamilyMerriweather-Regular rt_fontSize14',
		'quoteText': 'quoteColor rt_fontFamilyMerriweather-Light rt_fontSize18',
		'quoteSmallText': 'quoteSmallColor rt_fontFamilyMerriweather-Light rt_fontSize16',
		'responsiveText': 'responsiveColor responsiveFontSize responsiveFontFamily',
		'responsiveFontFamily': 'responsiveFontFamilyHelvetica'
	};
	TEXT_CLASS_MAPS['darkTheme'] = {
		'subtitleFontFamily': 'rt_fontFamilyMontserrat-Light',
		'titleFontFamily': 'rt_fontFamilyMontserrat-Bold',
		'titleSmallFontFamily': 'rt_fontFamilyMontserrat-Regular',
		'bodyFontFamily': 'rt_fontFamilyMontserrat-Regular',
		'bodySmallFontFamily': 'rt_fontFamilyMontserrat-Regular',
		'captionFontFamily': 'rt_fontFamilyMontserrat-Regular',
		'quoteFontFamily': 'rt_fontFamilyMontserrat-Light',
		'quoteSmallFontFamily': 'rt_fontFamilyMontserrat-Light',
		'subtitleFontSize': 'rt_fontSize18',
		'titleFontSize': 'rt_fontSize16',
		'titleSmallFontSize': 'rt_fontSize20',
		'bodyFontSize': 'rt_fontSize16',
		'bodySmallFontSize': 'rt_fontSize14',
		'captionFontSize': 'rt_fontSize14',
		'quoteFontSize': 'rt_fontSize18',
		'quoteSmallFontSize': 'rt_fontSize16',
		'subtitleText': 'subtitleColor rt_fontFamilyMontserrat-Light rt_fontSize18',
		'titleText': 'titleColor rt_fontFamilyMontserrat-Bold rt_fontSize20',
		'titleSmallText': 'titleSmallColor rt_fontFamilyMontserrat-Regular rt_fontSize20',
		'bodyText': 'bodyColor rt_fontFamilyMontserrat-Regular rt_fontSize16',
		'bodySmallText': 'bodySmallColor rt_fontFamilyMontserrat-Regular rt_fontSize14',
		'captionText': 'captionColor rt_fontFamilyMontserrat-Regular rt_fontSize14',
		'quoteText': 'quoteColor rt_fontFamilyMontserrat-Light rt_fontSize18',
		'quoteSmallText': 'quoteSmallColor rt_fontFamilyMontserrat-Light rt_fontSize16',
		'responsiveText': 'responsiveColor responsiveFontSize responsiveFontFamily',
		'responsiveFontFamily': 'responsiveFontFamilyHelvetica'
	};

	class TextWidgetTypesUpgradeHelper {

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		upgrade(spec) {
			if (spec && spec.widgets){
				this._upgradeWidgets(spec);
			}

			return Promise.resolve(spec);
		}

		_upgradeWidgets(spec) {
			_.each(spec.widgets, (model) => {
				if(model.type === TEXT_WIDGET_TYPE) {
					this._upgradeTextWidget(model, spec.theme);
				}
			});
		}

		_upgradeTextWidget(model, theme = THEME_DEFAULT) {
			if(!model.content) {
				return;
			}

			const table = model.content.translationTable;
			if(table) {
				for(const lang in table) {
					table[lang] = this._upgradeContent(theme, table[lang], model.isResponsive);
				}
			} else if(typeof model.content === 'string') {
				model.content = this._upgradeContent(theme, model.content, model.isResponsive);
			}
		}

		_upgradeContent(theme, content, isResponsive) {
			// this one is mainly for prior R6 upgrade
			content = content.replace(/<[^>]*class="[^>]*"[^>]*>/g, match => match.replace(/class=".*"/, function(match) {
				let replacedClasses = match;
				_.each(TEXT_CLASS_MAPS[theme], (newClass, oldClass) => {
					replacedClasses = replacedClasses.replace(oldClass, newClass);
				});
				return replacedClasses;
			}));

			if(isResponsive) {
				content = content.replace(/rt_fontSize[0-9]* ?/gi, '');
			}

			if(content.includes('contenteditable="true"')) {
				content = content.replace(/ ?contenteditable="true"/gi, '');
			}

			return content;
		}
	}

	return TextWidgetTypesUpgradeHelper;

});
